import { usePartnerId } from 'legacy/lut/classes/helpers/partner360/usePartnerId'
import { WidgetBusinessProfile } from 'legacy/lut/components/widgets/public/businessProfile/BusinessProfile'

import { Controller } from 'core-components/library/validation'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'

import { ICommitmentContactSelectionProps } from './models'

import styles from './CommitmentContactSelection.module.scss'

export const CommitmentContactSelection = (props: ICommitmentContactSelectionProps) => {
  const partnerId = usePartnerId({}, props.pid)

  return (
    <div className={styles.root}>
      <Controller>
        <WidgetBusinessProfile
          metrics={props.metrics}
          pid={partnerId}
          flexWidth={FlexDirectionBreak.p1012}
          widgetParams={{ TopPartnerID: partnerId }}
          hideHeader={false}
          selectProfile={(item) => {
            props.onApply(item.rawData)
          }}
        />
      </Controller>
    </div>
  )
}
